import { IAccessGrant } from "../../../../../shared/oversight-core/interfaces/access-grant";
import MaterialIcon from "../../../../../shared/oversight-core/ui-elements/material-icon/material-icon";
import {
  accessScopeLabels,
  formatGrantExpiry,
  getAccessLevelInfo,
} from "../../../../../shared/oversight-core/utils/get-org-user-info";
import styles from "./access-summary-row.module.scss";

interface IProps {
  grant: IAccessGrant;
  onRemove: () => void;
}

const AccessSummaryRow = (props: IProps) => {
  const { grant, onRemove } = props;

  return (
    <div className={styles.summaryRow}>
      <div className="overflow-hidden">
        <div className="text-light font-size-11">
          {grant.path.join(" › ") || accessScopeLabels[grant.scope]}
        </div>
        <div className="text-dark font-size-14 font-weight-600 text-truncate">
          {grant.scopeName}
        </div>
      </div>
      <div className="d-flex align-items-center gap-3 text-nowrap">
        <span className="text-primary font-size-13 font-weight-600">
          {getAccessLevelInfo(grant.level).label}
        </span>
        <span className="text-light font-size-13">
          {formatGrantExpiry(grant.expiresAt)}
        </span>
        <MaterialIcon
          icon="delete"
          size={20}
          color="#69768b"
          className="cursor-pointer"
          onClick={onRemove}
        />
      </div>
    </div>
  );
};

export default AccessSummaryRow;
